import Button from 'components/Form/Button';
import CustomSelect from 'components/Form/CustomSelect';
import SearchInput from 'components/Form/SearchInput';
import TextField from 'components/Form/TextField';
import { Icon, Icons } from 'components/Icon';
import { format } from 'date-fns';
import React, { useState } from 'react';
import { CSVLink } from 'react-csv';
import { printTable } from 'utils';

type IProps = {
  searchQuery: any;
  handleSearch: (val: any) => void;
  exportData: any;
  exportHeader: any;
  fileName: string;
  isLoading?: boolean;
  handleFilter?: (filter: Record<string, any> | null) => void;
  clearFilter?: () => void;
  filterData?: Record<string, any> | null;
  showFilter?: boolean;
};

export default function AdminTableProperties({
  searchQuery,
  handleSearch,
  exportData,
  exportHeader,
  fileName,
  isLoading,
  handleFilter,
  clearFilter,
  filterData,
  showFilter = true
}: Readonly<IProps>) {
  const [showFilterMenu, setShowFilterMenu] = useState(false);
  const [filter, setFilter] = useState<Record<string, any> | null>(null);

  const [date, setDate] = useState(
    filterData?.dateFilter ? filterData?.dateFilter : ''
  );
  const [product, setProduct] = useState<{
    label: string;
    value: any;
  } | null>(
    filterData?.productBought
      ? { value: filterData?.productBought, label: filterData?.productBought }
      : null
  );
  const [status, setStatus] = useState<{
    label: string;
    value: any;
  } | null>(
    filterData?.status
      ? { value: filterData?.status, label: filterData?.status }
      : null
  );

  return (
    <div>
      <div className="mt-4 flex items-center justify-between">
        <div className="flex items-center gap-x-5">
          <SearchInput
            name="search_query"
            placeholder="Search"
            value={searchQuery}
            onChange={handleSearch}
            size="lg"
            className="h-12 w-[25.3rem] rounded-[30px] border border-[#E9E9EA] bg-white"
          />
          {showFilter && (
            <div className="">
              <Button
                variant="secondary"
                size="sm"
                label={'Filter'}
                icon={
                  <Icon
                    name={Icons.Filter}
                    fill={`${showFilterMenu ? '#FFFFFF' : '#1D1929'}`}
                  />
                }
                iconPosition="right"
                type="button"
                onClick={() => {
                  setShowFilterMenu(prevState => !prevState);
                }}
                className={`h-[46px] w-28 rounded-[20px]   ${
                  showFilterMenu
                    ? 'border-none bg-[#FF6600] text-white'
                    : 'border border-[#E9E9EA] bg-[#C6C6C64D] text-[#1D1929]'
                }  `}
              />
            </div>
          )}
        </div>
        <div className="flex items-center gap-x-5">
          <CSVLink
            data={exportData}
            headers={exportHeader}
            filename={`${fileName}-report-${format(new Date(), 'dd-MMM-yyyy')}`}
            uFEFF={true}
          >
            <Button
              variant="secondary"
              size="sm"
              label="Export"
              icon={<Icon name={Icons.ExportArrowUp} />}
              loading={isLoading}
              disabled={isLoading}
              iconPosition="right"
              type="button"
              onClick={() => {}}
              iconLabelSpacing={8}
              className="w-[120px] rounded-2xl border border-[#E9E9EA] bg-white py-5 text-sm font-normal text-black"
            />
          </CSVLink>
          <Button
            variant="secondary"
            size="sm"
            label="Print"
            icon={<Icon name={Icons.Print} fill="#1D1929" />}
            iconPosition="right"
            type="button"
            iconLabelSpacing={8}
            className="w-[120px] rounded-2xl border border-[#E9E9EA] bg-white py-5 text-sm font-normal text-black"
            loading={isLoading}
            disabled={isLoading}
            onClick={printTable}
          />
        </div>
      </div>
      {showFilterMenu && (
        <div className="my-4 flex items-center justify-between rounded-md bg-white p-4 py-6">
          <div className="flex w-3/5 items-center gap-x-5">
            <TextField
              name="dateFilter"
              placeholder="Date: "
              value={date}
              onChange={e => {
                setDate(e.target.value);
                setFilter(prevState => ({
                  ...prevState,
                  dateFilter: e.target.value
                }));
              }}
              type="date"
              label={''}
              isRequired
              size="lg"
              className="rounded-md border-none bg-[#C6C6C633]"
            />
            <CustomSelect
              options={[
                { value: 'iWill', label: 'iWill' },
                { value: 'iWill Plus', label: 'iWill Plus' },
                { value: 'iWill Xtra', label: 'iWill Xtra' },
                { value: 'iWill Premium', label: 'iWill Premium' }
              ]}
              selectedOption={product}
              handleOptionChange={val => {
                setProduct(val);
                setFilter(prevState => ({
                  ...prevState,
                  productBought: val?.value
                }));
              }}
              placeholder="Product Bought:"
              useDefaultDropdownIcon
              name="maritalStatus"
              isSearchable
              className="-mt-2 h-[3rem] rounded-md border-none bg-[#C6C6C633]"
            />
            <CustomSelect
              options={[
                { value: 'In Active', label: 'In Active' },
                { value: 'In Progress', label: 'In Progress' },
                { value: 'Pending', label: 'Pending' },
                { value: 'Awaiting Approval', label: 'Awaiting Approval' },
                { value: 'Completed', label: 'Completed' },
                { value: 'Awaiting Signing', label: 'Awaiting Signing' }
              ]}
              selectedOption={status}
              handleOptionChange={val => {
                setStatus(val);
                setFilter(prevState => ({
                  ...prevState,
                  status: val?.value
                }));
              }}
              placeholder="Status:"
              useDefaultDropdownIcon
              name="maritalStatus"
              isSearchable
              className="-mt-2 h-[3rem] rounded-md border-none bg-[#C6C6C633]"
            />
          </div>
          <div className="flex items-center gap-5 px-1">
            <button onClick={clearFilter} className="font-medium underline">
              Clear
            </button>
            <Button
              variant="primary"
              size="custom"
              className="w-[8rem] rounded p-2.5 font-medium"
              label="Filter"
              type="button"
              onClick={() => handleFilter && handleFilter(filter)}
            ></Button>
          </div>
        </div>
      )}
    </div>
  );
}
